module.exports = __webpack_public_path__ + "img/logo-bold-dark-beta-small.89935d79.png";